'use client'
import PlansPanel from "../../components/plans/PlansPanel";
// import { useState } from "react";
// import { useEffect } from "react";
// import { membershipAxios } from "../../services/membership/MembershipAxios";
// import { useNavigate } from "react-router-dom";
// import Loader from "../../components/common/Loader";

export const PlansPage = () => {
	// const navigate = useNavigate();
	// const [isLoading, setIsLoading] = useState(false);

	// const setCreditsToContext = async () => {
	// 	try {
	// 		const membership = await membershipAxios();
	// 		navigate("/home");
	// 	} catch (error: any) {
	// 		console.error("Error fetching membership:", error);
	// 	}
	// };

	// useEffect(() => {
	// 	setCreditsToContext();
	// }, []);

	// if (isLoading) {
	// 	return (
	// 		<div className="flex justify-center items-center h-screen">
	// 			<Loader />
	// 		</div>
	// 	);
	// }

	return (
		<div>
			<PlansPanel />
		</div>
	);
};

